import { createRouter, createWebHistory } from 'vue-router';

import { createRouterErrorHandler } from './error-handler';
import { authGuard } from './guards';
import { routes } from './routes';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach(authGuard);
router.onError(createRouterErrorHandler(router));

export { router };
